import React, { useEffect } from 'react'
import { CourseReferenceForm } from '@Root/components'
import { modalActions } from '@Root/store'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import { courseReferenceSelectors, courseReferenceActions } from '@Store/studies'

export const EditCourseReference = ({ onOpenDescriptionModal }) => {
	const dispatch = useDispatch()
	const history = useHistory()
	const { studyProgrammeId, courseReferenceId } = useParams()
	const courseReference = useSelector(courseReferenceSelectors.courseReference)
	const isSuccess = useSelector(courseReferenceSelectors.isSuccess)
	const isLoading = useSelector(courseReferenceSelectors.isLoading)
	const options = useSelector(courseReferenceSelectors.options)
	const permissions = useSelector(courseReferenceSelectors.permissions)

	useEffect(() => {
		dispatch(
			courseReferenceActions.get({
				data: { studyProgrammeId, courseReferenceId },
				history,
			})
		)
		return () => {
			dispatch(courseReferenceActions.clearData())
		}
	}, [])

	const onDelete = () => {
		new Promise((resolve, reject) => {
			dispatch(
				modalActions.showModal('ConfirmationModal', {
					text: 'This Course Reference will be removed?',
					clickRejectButtonHandler: reject,
					clickResolveButtonHandler: resolve,
				})
			)
		})
			.then(async () => {
				dispatch(
					courseReferenceActions.delete({
						data: { studyProgrammeId, courseReferenceId },
						history,
					})
				)
			})
			.finally(() => {
				dispatch(modalActions.hideModal())
			})
	}

	const onSave = data => {
		dispatch(courseReferenceActions.edit({ data, courseReferenceId, studyProgrammeId }))
	}

	return (
		<CourseReferenceForm
			onOpenDescriptionModal={onOpenDescriptionModal}
			onSave={onSave}
			onDelete={onDelete}
			canEdit={permissions.form?.edit}
			canDelete={permissions.form?.delete}
			initialValue={courseReference}
			isLoading={isLoading}
			isSuccess={isSuccess}
			options={options}
		/>
	)
}
